// prettier-ignore
/* eslint-disable no-undef */
import FotoCorretor from '@assets/JuniorReis.png'
export interface Agent {
  id: string;
  userType: string;
  agentName: string;
  agentPhoto: string;
  phone: string;
  email: string;
  agentCode: string;
  propertiesManaged: string[];
  createdAt: string;
  updatedAt: string;
}

export const agentData: Agent[] = [
  {
    id: 'a1b2c3d4-e5f6-4a98-b8cc-123456789001',
    userType: 'Corretor',
    agentName: 'Carlos Mendes',
    agentPhoto:
      'https://img.freepik.com/vetores-premium/icones-de-usuarios-inclui-icones-de-usuario-icones-do-pessoal-simbolos-e-elementos-de-design-grafico-de-qualidade-premium_981536-526.jpg',
    phone: '+55 11 98765-4321',
    email: 'carlos.mendes@imobiliaria.com',
    agentCode: 'CRT001',
    propertiesManaged: ['AC1438', 'AC1439'],
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-03-01T10:30:00Z'
  },
  {
    id: 'a1b2c3d4-e5f6-4a98-b8cc-123456789002',
    userType: 'Corretor',
    agentName: 'Ana Santos',
    agentPhoto:
      'https://img.freepik.com/vetores-premium/icones-de-usuarios-inclui-icones-de-usuario-icones-do-pessoal-simbolos-e-elementos-de-design-grafico-de-qualidade-premium_981536-526.jpg',
    phone: '+55 11 97654-3210',
    email: 'ana.santos@imobiliaria.com',
    agentCode: 'CRT002',
    propertiesManaged: ['AC1440'],
    createdAt: '2024-01-05T00:00:00Z',
    updatedAt: '2024-03-05T14:15:00Z'
  },
  {
    id: 'a1b2c3d4-e5f6-4a98-b8cc-123456789003',
    userType: 'Secretária',
    agentName: 'Fernanda Oliveira',
    agentPhoto:
      'https://img.freepik.com/vetores-premium/icones-de-usuarios-inclui-icones-de-usuario-icones-do-pessoal-simbolos-e-elementos-de-design-grafico-de-qualidade-premium_981536-526.jpg',
    phone: '+55 11 91234-5678',
    email: 'fernanda.oliveira@imobiliaria.com',
    agentCode: 'SEC001',
    propertiesManaged: [],
    createdAt: '2024-02-01T00:00:00Z',
    updatedAt: '2024-03-10T09:00:00Z'
  },
  {
    id: 'a1b2c3d4-e5f6-4a98-b8cc-123456789004',
    userType: 'Proprietário',
    agentName: 'Junior Reis',
    agentPhoto:
      'https://img.freepik.com/vetores-premium/icones-de-usuarios-inclui-icones-de-usuario-icones-do-pessoal-simbolos-e-elementos-de-design-grafico-de-qualidade-premium_981536-526.jpg',
    phone: '+55 11 99999-8888',
    email: 'ricardo.almeida@imobiliaria.com',
    agentCode: 'OWN001',
    propertiesManaged: [],
    createdAt: '2023-01-01T00:00:00Z',
    updatedAt: '2024-03-15T16:45:00Z'
  },
  {
    id: 'a1b2c3d4-e5f6-4a98-b8cc-123456789005',
    userType: 'Administrador',
    agentName: 'Admin Sistema',
    agentPhoto:
      'https://img.freepik.com/vetores-premium/icones-de-usuarios-inclui-icones-de-usuario-icones-do-pessoal-simbolos-e-elementos-de-design-grafico-de-qualidade-premium_981536-526.jpg',
    phone: '+55 11 98888-7777',
    email: 'admin@imobiliaria.com',
    agentCode: 'ADM001',
    propertiesManaged: [],
    createdAt: '2023-01-01T00:00:00Z',
    updatedAt: '2024-03-20T08:00:00Z'
  }
];
